import __request__ from 'routing/request';
/**
 * Get Graylog Enterprise license info
 */
export function licenseInfo(): Promise<unknown> {
    return __request__('GET', '/enterprise/license/info', null, {}, {
        'Accept': ['application/json']
    });
}
